import {
  sessionUserSchema,
  totpSetupSchema,
  type LoginInput,
  type SessionUser,
  type TotpSetup,
} from '@app/shared';
import type { z } from 'zod';
import type { totpDisableInputSchema, totpEnableInputSchema, totpSetupInputSchema } from '@app/shared';
import { apiFetch } from '@/lib/api';

export type TotpSetupInput = z.infer<typeof totpSetupInputSchema>;
export type TotpEnableInput = z.infer<typeof totpEnableInputSchema>;
export type TotpDisableInput = z.infer<typeof totpDisableInputSchema>;

export function fetchSession(): Promise<SessionUser> {
  return apiFetch('/api/auth/me', { schema: sessionUserSchema });
}

export function login(input: LoginInput): Promise<SessionUser> {
  return apiFetch('/api/auth/login', { method: 'POST', body: input, schema: sessionUserSchema });
}

export function logout(): Promise<void> {
  return apiFetch('/api/auth/logout', { method: 'POST' });
}

export function setupTotp(input: TotpSetupInput): Promise<TotpSetup> {
  return apiFetch('/api/auth/totp/setup', { method: 'POST', body: input, schema: totpSetupSchema });
}

export function enableTotp(input: TotpEnableInput): Promise<SessionUser> {
  return apiFetch('/api/auth/totp/enable', { method: 'POST', body: input, schema: sessionUserSchema });
}

export function disableTotp(input: TotpDisableInput): Promise<SessionUser> {
  return apiFetch('/api/auth/totp/disable', { method: 'POST', body: input, schema: sessionUserSchema });
}
